import React from "react";
import { Card, Skeleton } from "antd";

const SkeletonCard = () => {
  return (
    <Card
      style={{ borderRadius: 12, height: "100%", width: "100%", overflow: "hidden" }}
      cover={
        <div style={{ height: 160, background: "#f0f2f5", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
           {/* Silueta de la imagen */}
           <Skeleton.Button active style={{ width: 100, height: 100 }} />
        </div>
      }
    >
      {/* Silueta del texto y rating */}
      <Skeleton active paragraph={{ rows: 2 }} title={false} />
      
      {/* Silueta del footer verde */}
      <div style={{ 
        height: 45, 
        background: "#e8f5e9", 
        marginTop: 10, 
        borderRadius: 4,
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px'
      }}>
        <Skeleton.Button active style={{ width: 60, height: 20 }} />
        <Skeleton.Avatar active size="small" shape="circle" />
      </div>
    </Card>
  );
};

export default SkeletonCard;